export default __webpack_public_path__ + "static/media/gerrit.5a2d2931.png";